import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SvgCacheService {
  private http = inject(HttpClient);
  private cache = new Map<string, Observable<string>>();

  getSvg(path: string): Observable<string> {
    if (!this.cache.has(path)) {
      // Utiliser shareReplay pour partager la même requête HTTP entre tous les abonnés
      const svg$ = this.http.get(path, { responseType: 'text' }).pipe(
        shareReplay(1) // Cache le dernier résultat et le partage
      );
      this.cache.set(path, svg$);
    }
    return this.cache.get(path)!;
  }

  clearCache(): void {
    this.cache.clear();
  }
}
